import React, { useEffect, useState } from 'react';
import { ChevronRightIcon, SaveIcon, XIcon } from 'lucide-react';
import { useNavigation } from '../../context/NavigationContext';
export const AddEditListPage = ({
  editMode = false,
  itemId = null
}) => {
  const {
    navigate
  } = useNavigation();
  const [formData, setFormData] = useState({
    name: '',
    category: 'Jurisdictions',
    description: '',
    status: 'active',
    // Jurisdiction specific fields
    jurisdictionLevel: 'region',
    parentRegion: '',
    parentZone: ''
  });
  // Sample data for dropdowns
  const regions = ['Oromia', 'Amhara', 'Tigray', 'SNNPR', 'Addis Ababa'];
  const zones = {
    Oromia: ['East Shewa', 'West Shewa', 'Arsi', 'Bale', 'Jimma'],
    Amhara: ['North Shewa', 'South Gondar', 'North Gondar', 'East Gojjam'],
    Tigray: ['Central Tigray', 'Eastern Tigray', 'Southern Tigray'],
    SNNPR: ['Sidama', 'Gurage', 'Wolayta', 'Gamo'],
    'Addis Ababa': ['Addis Ketema', 'Akaki Kality', 'Arada', 'Bole', 'Kirkos']
  };
  // Reset jurisdiction fields when category changes
  useEffect(() => {
    if (formData.category !== 'Jurisdictions') {
      setFormData(prev => ({
        ...prev,
        jurisdictionLevel: 'region',
        parentRegion: '',
        parentZone: ''
      }));
    }
  }, [formData.category]);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => {
      const newData = {
        ...prev,
        [name]: value
      };
      // Reset child selections when parent changes
      if (name === 'jurisdictionLevel') {
        if (value === 'region') {
          newData.parentRegion = '';
          newData.parentZone = '';
        } else if (value === 'zone') {
          newData.parentZone = '';
        }
      }
      if (name === 'parentRegion') {
        newData.parentZone = '';
      }
      return newData;
    });
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Here you would implement the actual saving logic
    console.log('Form submitted:', formData);
    // Navigate back to the lists page after saving
    navigate('/lists');
  };
  const handleCancel = () => {
    navigate('/lists');
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-4047">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-4048">
        {/* Breadcrumb */}
        <div className="flex items-center text-sm text-gray-500 mb-8" data-id="element-4049">
          <a href="/" className="hover:text-gray-700" data-id="element-4050">
            Dashboard
          </a>
          <ChevronRightIcon className="h-4 w-4 mx-2" data-id="element-4051" />
          <a href="#" onClick={() => navigate('/lists')} className="hover:text-gray-700" data-id="element-4052">
            Lists
          </a>
          <ChevronRightIcon className="h-4 w-4 mx-2" data-id="element-4053" />
          <span className="text-gray-900" data-id="element-4054">
            {editMode ? 'Edit' : 'Add'} List Item
          </span>
        </div>
        {/* Header */}
        <div className="mb-8" data-id="element-4055">
          <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-4056">
            {editMode ? 'Edit' : 'Add'} List Item
          </h1>
          <p className="text-gray-600" data-id="element-4057">
            {editMode ? 'Update an existing list item with the form below' : 'Create a new list item by filling out the form below'}
          </p>
        </div>
        {/* Form */}
        <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-4058">
          <form onSubmit={handleSubmit} data-id="element-4059">
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2" data-id="element-4060">
              <div className="col-span-2" data-id="element-4061">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4062">
                  Name*
                </label>
                <input type="text" name="name" required value={formData.name} onChange={handleChange} className="block w-full px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="Enter name" data-id="element-4063" />
              </div>
              <div data-id="element-4064">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4065">
                  Category*
                </label>
                <select name="category" required value={formData.category} onChange={handleChange} className="block w-full px-3 py-2 border border-gray-300 rounded-md text-sm" data-id="element-4066">
                  <option value="Jurisdictions" data-id="element-4067">Jurisdictions</option>
                  <option value="Organizations" data-id="element-4068">Organizations</option>
                  <option value="Agencies" data-id="element-4069">Agencies</option>
                  <option value="Categories" data-id="element-4070">Categories</option>
                  <option value="Reason Codes" data-id="element-4071">Reason Codes</option>
                </select>
              </div>
              <div data-id="element-4072">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4073">
                  Status*
                </label>
                <select name="status" required value={formData.status} onChange={handleChange} className="block w-full px-3 py-2 border border-gray-300 rounded-md text-sm" data-id="element-4074">
                  <option value="active" data-id="element-4075">Active</option>
                  <option value="inactive" data-id="element-4076">Inactive</option>
                </select>
              </div>
              {/* Jurisdiction specific fields */}
              {formData.category === 'Jurisdictions' && <>
                  <div data-id="element-4077">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4078">
                      Jurisdiction Level*
                    </label>
                    <select name="jurisdictionLevel" required value={formData.jurisdictionLevel} onChange={handleChange} className="block w-full px-3 py-2 border border-gray-300 rounded-md text-sm" data-id="element-4079">
                      <option value="region" data-id="element-4080">Region</option>
                      <option value="zone" data-id="element-4081">Zone</option>
                      <option value="woreda" data-id="element-4082">Woreda</option>
                      <option value="kebele" data-id="element-4083">Kebele</option>
                    </select>
                  </div>
                  {formData.jurisdictionLevel !== 'region' && <div data-id="element-4084">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4085">
                        Parent Region*
                      </label>
                      <select name="parentRegion" required value={formData.parentRegion} onChange={handleChange} className="block w-full px-3 py-2 border border-gray-300 rounded-md text-sm" data-id="element-4086">
                        <option value="" data-id="element-4087">Select Region</option>
                        {regions.map(region => <option key={region} value={region} data-id="element-4088">
                            {region}
                          </option>)}
                      </select>
                    </div>}
                  {(formData.jurisdictionLevel === 'woreda' || formData.jurisdictionLevel === 'kebele') && formData.parentRegion && <div data-id="element-4089">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4090">
                          Parent Zone*
                        </label>
                        <select name="parentZone" required value={formData.parentZone} onChange={handleChange} className="block w-full px-3 py-2 border border-gray-300 rounded-md text-sm" data-id="element-4091">
                          <option value="" data-id="element-4092">Select Zone</option>
                          {zones[formData.parentRegion]?.map(zone => <option key={zone} value={zone} data-id="element-4093">
                              {zone}
                            </option>)}
                        </select>
                      </div>}
                </>}
              <div className="col-span-2" data-id="element-4094">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4095">
                  Description
                </label>
                <textarea name="description" value={formData.description} onChange={handleChange} rows={4} className="block w-full px-3 py-2 border border-gray-300 rounded-md text-sm" placeholder="Enter description" data-id="element-4096" />
              </div>
            </div>
            <div className="mt-6 flex justify-end space-x-3" data-id="element-4097">
              <button type="button" onClick={handleCancel} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-4098">
                Cancel
              </button>
              <button type="submit" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700" data-id="element-4099">
                <SaveIcon className="h-4 w-4 mr-2" data-id="element-4100" />
                {editMode ? 'Update' : 'Save'} List Item
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>;
};